"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
class QueryStringService {
    constructor() {
        this.refreshTokenBehaviorSubject = new rxjs_1.BehaviorSubject(null);
        this.refreshTokenObservable =
            this.refreshTokenBehaviorSubject.asObservable();
    }
    static fromInstance() {
        return new QueryStringService();
    }
    getRefreshTokenObservable() {
        return this.refreshTokenObservable;
    }
    getToken() {
        return this.refreshTokenBehaviorSubject.getValue();
    }
    pushToken(value) {
        this.refreshTokenBehaviorSubject.next(value);
    }
}
exports.default = QueryStringService;
